import React from 'react'
import moment from 'moment'
import LocationsAffected from '../../../../../common/components/locationsAffected'
import AmountCell from '../tableCells/amount'
import { SortableTableHeader } from '../../../../../app/components/statelessDataTable/components/tableColumn'
import MinWageNotificationDetail from '../detail/index'
import { locationsAffectedTooltip } from './columns.tooltip'
import { StyledSpan } from '../../../../../theme/Global'

const hasIndexedWage = (cell) => {
  const hasIndexedStandardWage = cell.row.original.wages['wage rate']
    && cell.row.original.wages['wage rate'].new
    && cell.row.original.wages['wage rate'].new.indexed
  const hasIndexedTippedWage = cell.row.original.wages.gratuities
    && cell.row.original.wages.gratuities.new
    && cell.row.original.wages.gratuities.new.indexed
  return hasIndexedStandardWage || hasIndexedTippedWage
}

const minWagesNotificationsTableColumns = ({ tipped, sortOptions, eventHandlers }) => {
  const columns = [
    {
      Header: () => (
        <SortableTableHeader
          {...{
            field: 'notificationDate',
            text: 'Date of Change',
            sortOptions,
            eventHandlers
          }}
        />
      ),
      accessor: 'notificationDate',
      width: 250,
      minWidth: 0, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => <div className="text">{moment(cell.row.original.notificationDate).format('MM/DD/YYYY')}</div>,
      canSort: true
    },
    {
      Header: () => (
        <SortableTableHeader
          {...{
            field: 'locations',
            text: 'Locations Affected',
            sortOptions,
            eventHandlers,
            tooltip: { component: locationsAffectedTooltip }
          }}
        />
      ),
      accessor: 'locations',
      width: 250,
      minWidth: 0, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => (
        <LocationsAffected
          {...{
            data: {
              jurisdiction: cell.row.original,
              locations: cell.row.original.locations
            },
            canOpen: true,
            indexed: hasIndexedWage(cell),
            modal: <MinWageNotificationDetail includeTips={tipped} notification={cell.row.original} />
          }}
        />
      ),
      canSort: true
    },
    {
      Header: () => (
        <SortableTableHeader
          {...{
            field: 'law',
            text: 'Law',
            sortOptions,
            eventHandlers
          }}
        />
      ),
      accessor: 'law',
      width: 250,
      minWidth: 0, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => (
        <div className="text">{cell.row.original.law}</div>
      ),
      canSort: true
    },
    {
      Header: () => (
        <SortableTableHeader
          {...{
            field: 'notificationNewWage',
            text: 'New Wage',
            sortOptions,
            eventHandlers
          }}
        />
      ),
      accessor: 'notificationNewWage',
      width: 250,
      minWidth: 0, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => (cell.row.original.notificationNewWage ? (
        <AmountCell
          amount={cell.row.original.wages['wage rate'].new.amount}
          jurisdiction={cell.row.original.wages['wage rate'].new.jurisdiction}
          jurisdictionName={cell.row.original.wages['wage rate'].new.jurisdictionName}
          indexed={cell.row.original.wages['wage rate'].new.indexed}
        />
      ) : (
        <StyledSpan>No Change</StyledSpan>
      )),
      canSort: true
    },
    {
      Header: () => (
        <SortableTableHeader
          {...{
            field: 'notificationPrevailingWage',
            text: 'Min. Wage',
            sortOptions,
            eventHandlers
          }}
        />
      ),
      accessor: 'notificationPrevailingWage',
      width: 250,
      minWidth: 0, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => (cell.row.original.notificationPrevailingWage ? (
        <AmountCell
          amount={cell.row.original.wages['wage rate'].old.amount}
          jurisdiction={cell.row.original.wages['wage rate'].old.jurisdiction}
          jurisdictionName={cell.row.original.wages['wage rate'].old.jurisdictionName}
          indexed={cell.row.original.wages['wage rate'].old.indexed}
        />
      ) : (
        <StyledSpan>No Change</StyledSpan>
      )),
      canSort: true
    }
  ]

  const tippedColumns = [
    {
      Header: () => (
        <SortableTableHeader
          {...{
            field: 'notificationNewTipWage',
            text: 'New Tip. Wage',
            sortOptions,
            eventHandlers
          }}
        />
      ),
      accessor: 'notificationNewTipWage',
      width: 250,
      minWidth: 0, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => (cell.row.original.hasMultipleTippedWages ? <StyledSpan>See location details</StyledSpan> : (
        <div>
          {cell.row.original.notificationNewTipWage ? (
            <AmountCell
              amount={cell.row.original.wages.gratuities.new.amount}
              jurisdiction={cell.row.original.wages.gratuities.new.jurisdiction}
              jurisdictionName={cell.row.original.wages.gratuities.new.jurisdictionName}
              indexed={cell.row.original.wages.gratuities.new.indexed}
            />
          ) : (
            <StyledSpan>No Change</StyledSpan>
          )}
        </div>
      )),
      canSort: true
    },
    {
      Header: () => (
        <SortableTableHeader
          {...{
            field: 'notificationPrevailingTipWage',
            text: 'Tip. Wage',
            sortOptions,
            eventHandlers
          }}
        />
      ),
      accessor: 'notificationPrevailingTipWage',
      width: 250,
      minWidth: 0, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => (cell.row.original.hasMultipleTippedWages ? <StyledSpan>See location details</StyledSpan> : (
        <div>
          {cell.row.original.notificationPrevailingTipWage ? (
            <AmountCell
              amount={cell.row.original.wages.gratuities.old.amount}
              jurisdiction={cell.row.original.wages.gratuities.old.jurisdiction}
              jurisdictionName={cell.row.original.wages.gratuities.old.jurisdictionName}
              indexed={cell.row.original.wages.gratuities.old.indexed}
            />
          ) : (
            <StyledSpan>No Change</StyledSpan>
          )}
        </div>
      )),
      canSort: true
    }
  ]

  return tipped ? columns.concat(tippedColumns) : columns
}

export default minWagesNotificationsTableColumns
